import React from "react";
import { useTranslation } from "react-i18next";

import CustomInput from "../../shared/custom-components/customInput";
import StepButtons from "./stepButtons";

const AdressForm = ({ initialState = {}, nextStep, reviewMode }) => {
  const { t } = useTranslation();
  return (
    <div className={`register-provider-adress ${reviewMode ? "w-100" : ""}`}>
      <h3 className="form-title">{t(`${baseName}title`)}</h3>
      {items.map((item) => (
        <CustomInput
          key={item}
          name={item}
          placeholder={t(`${baseName}${item}Placeholder`)}
          value={initialState[item]}
          disabled={true}
          className="input-new-provider-fix"
        />
      ))}
      {!reviewMode && <StepButtons nextStep={() => nextStep(null)} />}
    </div>
  );
};

export default AdressForm;

const baseName = "registerProvider.forms.address.";
const items = ["address", "city", "countryName"];
